import { useState } from 'react';
import styles from './Initializer.module.css';
import formStyles from './ExpertiseFormStep.module.css';

function ExpertiseFormStep({
  personaData,
  setPersonaData,
  onNext,
  onBack,
  currentStepNumber,
  totalSteps,
}) {
  const [formData, setFormData] = useState(
    personaData.expertiseData || {
      domain: '',
      professionalSummary: '',
      skills: [],
      workHistory: [],
    }
  );
  const [currentSkill, setCurrentSkill] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddSkill = () => {
    if (currentSkill && !formData.skills.includes(currentSkill)) {
      setFormData((prev) => ({
        ...prev,
        skills: [...prev.skills, currentSkill],
      }));
    }
    setCurrentSkill('');
  };

  const handleRemoveSkill = (skillToRemove) => {
    setFormData((prev) => ({
      ...prev,
      skills: formData.skills.filter((s) => s !== skillToRemove),
    }));
  };

  const handleNext = () => {
    setPersonaData((prevData) => ({ ...prevData, expertiseData: formData }));
    onNext();
  };

  return (
    <div>
      <h3>
        Step {currentStepNumber}/{totalSteps}: Detail Your Expertise
      </h3>
      <div className={styles.formGroup}>
        <label htmlFor="domain">Primary Domain</label>
        <input
          type="text"
          id="domain"
          name="domain"
          value={formData.domain}
          onChange={handleChange}
          placeholder="e.g., Medicine, Law, Software Engineering"
        />
      </div>
      <div className={styles.formGroup}>
        <label htmlFor="professionalSummary">Professional Summary</label>
        <textarea
          id="professionalSummary"
          name="professionalSummary"
          rows="4"
          value={formData.professionalSummary}
          onChange={handleChange}
          placeholder="A brief summary of your career, skills, and professional goals."
        />
      </div>
      <div className={styles.formGroup}>
        <label htmlFor="skills">Key Skills</label>
        <div className={formStyles.tagInputContainer}>
          <input
            type="text"
            id="skills"
            value={currentSkill}
            onChange={(e) => setCurrentSkill(e.target.value)}
            onKeyDown={(e) =>
              e.key === 'Enter' && (e.preventDefault(), handleAddSkill())
            }
            placeholder="Type a skill and press Enter"
          />
          <button
            type="button"
            onClick={handleAddSkill}
            className="action-button secondary"
          >
            Add
          </button>
        </div>
        <div className={formStyles.tagContainer}>
          {formData.skills.map((skill) => (
            <span key={skill} className={formStyles.tag}>
              {skill}
              <button onClick={() => handleRemoveSkill(skill)}>&times;</button>
            </span>
          ))}
        </div>
      </div>
      <div className={styles.buttonGroup}>
        <button onClick={onBack} className="action-button secondary">
          Back
        </button>
        <button onClick={handleNext} className="action-button primary">
          Next
        </button>
      </div>
    </div>
  );
}

export default ExpertiseFormStep;
